import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';

// The Payment icons have a standard size 40 x 24 and chroma
const Discover: FC<IconV2Props> = ({ icon, className }) => (
  <svg
    width="40"
    height="24"
    viewBox="0 0 40 24"
    xmlns="http://www.w3.org/2000/svg"
    className={cn(className, `svg-icon--${icon}`)}
  >
    <defs>
      <radialGradient
        cx="50%"
        cy="50%"
        fx="50%"
        fy="50%"
        r="49.983%"
        gradientTransform="matrix(0 1 -.97759 0 .989 0)"
        id="a"
      >
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#F58220" offset="99.966%" />
      </radialGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0h40v24H0V0Zm1 1v22h38V1H1Z"
        fill="#D5D6D6"
        fillRule="nonzero"
      />
      <path
        d="m19.754 12.873.584 1.445.456-1.302.006-.018h.258l-.719 1.973-.585-1.458-.578 1.44-.007.018-.719-1.973h.258l.462 1.32.56-1.385.007-.017.017-.043Zm-7.334.02 1.385 1.451.024.025V13h.238v1.953l-1.384-1.449-.024-.024v1.364h-.239v-1.95Zm10.272.074c.53 0 .96.428.96.955a.957.957 0 0 1-.96.951.957.957 0 0 1-.96-.95c0-.528.43-.956.96-.956Zm-6.712.031v.226h-.735v.499h.713v.223h-.713v.672h.735v.225h-.974v-1.845h.974Zm1.862 0v.226H17.4v1.619h-.24v-1.62h-.436v-.225h1.117Zm6.925 0c.458 0 .68.169.68.518a.487.487 0 0 1-.44.509l.57.803.01.015h-.037l-.262-.009s-.439-.637-.519-.763l-.012-.022h-.031v.794h-.239v-1.845h.28Zm1.857 0v.748l.075-.076.56-.563.108-.109h.323l-.869.862c.024.023.776.85.883.969l.013.014h-.044l-.291-.007s-.703-.787-.729-.814a.497.497 0 0 1-.023.022l-.006.003v.796h-.239v-1.845h.239Zm-3.932.194a.726.726 0 0 0-.722.728c0 .402.324.73.722.73.398 0 .72-.328.72-.73a.725.725 0 0 0-.72-.728Zm2.075.032h-.041v.61h.043c.218 0 .439-.036.439-.304 0-.284-.209-.306-.44-.306Zm-.059-7.102 1.441 3.627 1.459-3.627h1.141l-2.332 5.537h-.567l-2.292-5.537h1.15Zm-13.368-.09c.526 0 1.013.16 1.433.474l.154.125-.55.72c-.275-.307-.534-.436-.85-.436-.454 0-.786.258-.786.599 0 .29.186.445.819.679 1.198.438 1.554.827 1.554 1.685 0 1.044-.77 1.774-1.862 1.774-.74 0-1.294-.27-1.756-.871l-.114-.158.68-.656c.242.47.647.72 1.149.72.47 0 .818-.323.818-.761a.646.646 0 0 0-.316-.558c-.105-.066-.315-.163-.729-.308-.988-.357-1.327-.737-1.327-1.483 0-.881.729-1.545 1.683-1.545ZM16.32 6c.389 0 .724.07 1.103.238l.193.092v1.24c-.437-.43-.819-.607-1.32-.607-.989 0-1.765.818-1.765 1.853 0 1.094.753 1.863 1.813 1.863.425 0 .767-.134 1.133-.46l.14-.13v1.238c-.479.226-.867.316-1.32.316-1.604 0-2.851-1.23-2.851-2.819C13.446 7.255 14.725 6 16.32 6Zm-7.336.122v5.399H7.932v-5.4h1.052Zm23.23 0v.914H30.28v1.198h1.86v.915h-1.86v1.458h1.935v.914h-2.987v-5.4h2.987Zm2.259 0c1.215 0 1.91.582 1.91 1.593 0 .771-.38 1.296-1.076 1.494l-.155.038 1.702 2.274h-1.296l-1.456-2.17h-.138v2.17H32.91v-5.4h1.563Zm-29.925 0c1.707 0 2.898 1.108 2.898 2.702 0 .795-.365 1.564-.98 2.074-.518.43-1.11.623-1.926.623H3v-5.4Zm-.211.914h-.283v3.57h.283c.68 0 1.11-.129 1.442-.43.364-.322.582-.84.582-1.36 0-.518-.218-1.02-.582-1.343-.35-.315-.761-.437-1.442-.437Zm29.95-.065h-.323v1.636h.306c.674 0 1.03-.293 1.03-.835 0-.525-.356-.801-1.013-.801Zm2.683-.772c.226 0 .41.188.41.415a.414.414 0 0 1-.41.416.415.415 0 1 1 0-.831Zm0 .076a.335.335 0 0 0-.333.34c0 .189.148.34.332.34.18 0 .327-.153.327-.34a.336.336 0 0 0-.327-.34Zm-.023.103c.116 0 .18.051.18.146 0 .05-.021.09-.06.114l-.044.019.158.197h-.141l-.133-.185v.185h-.113v-.476h.153Zm-.004.087h-.036v.174h.034c.092 0 .14-.03.14-.088 0-.057-.047-.086-.138-.086Z"
        fill="#001722"
      />
      <path
        d="M17.895.02c-1.59 0-2.88 1.243-2.88 2.775 0 1.63 1.234 2.848 2.88 2.848 1.605 0 2.872-1.234 2.872-2.816 0-1.572-1.259-2.806-2.872-2.806"
        fill="url(#a)"
        transform="translate(3 6)"
      />
      <path d="M39 14s-9.535 6.216-27 9h27v-9Z" fill="#F4811F" />
    </g>
  </svg>
);

export default Discover;
